import MoreVert from '@mui/icons-material/MoreVert';
import {
	Button,
	ButtonGroup,
	ClickAwayListener,
	Grow,
	MenuItem,
	MenuList,
	Modal,
	Paper,
	Popper,
} from '@mui/material';
import { descargarComprobante } from 'actions/Comprobante/comprobante';
import MDBox from 'components/MDBox';
import Cancelar from 'pantallas/Comprobantes/components/Cancelar';
import Email from 'pantallas/Comprobantes/components/Email';
import Timbrar from 'pantallas/Comprobantes/components/Timbrar';
import PdfMakeComplementoPago from 'pantallas/Comprobantes/Data/acciones/components/PdfMakeComplementoPago/PdfMakeComplementoPago';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
interface iProps {
	item: any;
	setDatos: any;
	isMyDataValid: any;
	modoModal: any;
	setComprobanteToUpdate: any;
}
const Acciones = ({
	item,
	setDatos,
	isMyDataValid,
	modoModal,
	setComprobanteToUpdate,
}: iProps) => {
	const navigate = useNavigate();
	const anchorRef = React.useRef<HTMLDivElement>(null);
	const [openModal, setOpenModal] = React.useState(false);
	const [open, setOpen] = React.useState(false);

	const [pantallaId, setPantallaId] = useState<number | null>(null);
	const handleToggle = () => setOpen((prevOpen) => !prevOpen);
	const handleCloseModal = () => setOpenModal(false);
	const handleClose = (event: Event) => {
		if (
			anchorRef.current &&
			anchorRef.current.contains(event.target as HTMLElement)
		) {
			return;
		}

		setOpen(false);
	};
	const cancelar = () => {
		if (isMyDataValid()) {
			setOpenModal(true); // abrimos el modal
			setOpen(false);
			setPantallaId(6);
		}
	};

	//Pantallas Modal
	const pantalla = () => {
		switch (pantallaId) {
			case 1: // Enviar por correo
				return (
					<Email
						closeModal={() => {
							handleCloseModal();
						}}
						item={item}
						setComprobantesListData={setDatos}
						tipoComprobante={'CP'}
					/>
				);
			case 2: // Timbrar
				return (
					<Timbrar
						closeModal={() => {
							handleCloseModal();
						}}
						item={item}
						// handleOpen={handleOpen}
						setComprobantesListData={setDatos}
						tipoComprobante={'CP'}
					/>
				);
			case 6: // cancelar
				return (
					<Cancelar
						closeModal={() => {
							handleCloseModal();
						}}
						item={item}
						setComprobantesListData={setDatos}
						tipoComprobante={'CP'}
					/>
				);

			default:
				break;
		}
	};
	const [xmlButton, setXmlButton] = useState('Ver XML');
	const [comprobante, setComprobante] = useState({ estatus: false });
	const verXML = (uuid: string): void => {
		setComprobante({ estatus: true });
		console.log('uuid', uuid);
		const comprobanteData = descargarComprobante(uuid);
		comprobanteData
			.then((respuesta) => {
				console.log(respuesta);
				if (respuesta.status === 200) {
					setComprobante({ estatus: false });
					const url = window.URL.createObjectURL(
						new Blob([respuesta.data], { type: 'text/xml' })
					);
					const link = document.createElement('a');
					link.href = url;
					link.target = '_blank';
					link.setAttribute('href', url);
					document.body.appendChild(link);
					link.click();
				}
			})
			.catch((error) => {
				if (error.response.status === 500) {
					setComprobante({ estatus: false });
					console.log('error500');
					console.log(error.response.data.message);
				} else if (error.response.status === 400) {
					setComprobante({ estatus: false });
					console.log('error400');
					console.log(error.response.data.message);
				} else if (error.response.status === 401) {
					setComprobante({ estatus: false });
					console.log('error401');
					console.log(error.response.data);
				} else if (error.response.status === 403) {
					setComprobante({ estatus: false });
					console.log('error403');
					console.log(error.response.data.message);
				} else if (error.response.status === 404) {
					setComprobante({ estatus: false });
					console.log('error404');
					console.log(error.response.data.message);
				} else {
					setComprobante({ estatus: false });
					console.log(error.response.data.message);
				}
			});
	};
	const openAccion = (pantallaId: number): void => {
		if ([3, 4].includes(pantallaId)) {
			// handleToggle();
			switch (pantallaId) {
				case 3: // Descargar XML
					verXML(item.uuid);
					// navigate(`/comprobante/xml/${item.uuid}`);

					break;
				case 4: // Descargar PDF
					handleToggle();
					navigate(`/comprobante/pdf/${item.uuid}`);
					break;

				default:
					break;
			}
		} else if (pantallaId === 0) {
			//Editar
			modoModal(1, { id: 1 });
			setComprobanteToUpdate(item);
			handleToggle();
		} else {
			setPantallaId(pantallaId);
			setOpenModal(true);
			handleToggle();
		}
	};

	useEffect(() => {
		if (comprobante.estatus) setXmlButton('Cargando...');
		if (!comprobante.estatus) setXmlButton('Ver XML');
	}, [comprobante]);

	const descargarComprobantes = () => {
		setOpen(false);
		navigate(`/comprobante/descarga/${item.uuid}`);
	};

	return (
		<>
			<ButtonGroup variant='text' ref={anchorRef} aria-label='split button'>
				<Button
					size='small'
					aria-controls={open ? 'split-button-menu' : undefined}
					aria-expanded={open ? 'true' : undefined}
					aria-label='select merge strategy'
					aria-haspopup='menu'
					onClick={handleToggle}
					style={{ backgroundColor: '#00A3BE' }}
				>
					<MoreVert style={{ color: 'white' }} />
				</Button>
			</ButtonGroup>
			<Popper
				open={open}
				anchorEl={anchorRef.current}
				role={undefined}
				transition
				disablePortal
				style={{ zIndex: '3000' }}
			>
				{({ TransitionProps, placement }) => (
					<Grow
						{...TransitionProps}
						style={{
							transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
						}}
					>
						<Paper>
							<ClickAwayListener onClickAway={handleClose}>
								{item.timbrado ? (
									<MenuList id='split-button-menu' autoFocusItem>
										<MenuItem onClick={() => openAccion(1)}>Enviar</MenuItem>
										<MenuItem
											onClick={() => openAccion(3)}
											disabled={comprobante.estatus}
										>
											{xmlButton}
										</MenuItem>
										<PdfMakeComplementoPago
											uuid={item.uuid}
											tipo={'abrir'}
											isMyDataValid={isMyDataValid}
										/>
										<MenuItem onClick={descargarComprobantes}>
											Opciones de descarga
										</MenuItem>
										{item.timbrado &&
											item.estatus_comprobante_id !== 1 &&
											item.estatus_comprobante_id !== 5 && (
												<MenuItem onClick={cancelar}>Cancelar comprobante</MenuItem>
											)}
									</MenuList>
								) : (
									<MenuList id='split-button-menu' autoFocusItem>
										<MenuItem onClick={() => openAccion(0)}>Editar</MenuItem>
										<MenuItem onClick={() => openAccion(2)}>Timbrar</MenuItem>
										<PdfMakeComplementoPago
											uuid={item.uuid}
											tipo={'abrir'}
											isMyDataValid={isMyDataValid}
										/>
									</MenuList>
								)}
							</ClickAwayListener>
						</Paper>
					</Grow>
				)}
			</Popper>

			<Modal
				open={openModal}
				onClose={handleCloseModal}
				style={{
					maxHeight: '750px',
					maxWidth: '1350px',
					alignItems: 'center',
					margin: 'auto',
					justifyContent: 'center',
				}}
			>
				<MDBox>{pantalla()}</MDBox>
			</Modal>
		</>
	);
};

export default Acciones;
